<template>
    <v-flex xs12 md10 offset-md1>
        <v-toolbar color="blue" dark>
            <v-toolbar-title>Add New Group</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <v-card-title>
                <v-text-field
                        v-model="newGroup"
                        label="New group name"
                        single-line
                        hide-details
                ></v-text-field>
                <v-btn color="default" @click="startAdd">Add</v-btn>
            </v-card-title>
        </v-card>
    </v-flex>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        name: "GroupNew",
        data() {
            return {
                newGroup: ''
            }
        },
        methods: {
            ...mapActions(['addNewGroup', 'removeGroup']),
            startAdd: function () {
                if (this.newGroup !== '') {
                    this.addNewGroup(this.newGroup)
                    this.newGroup = ''
                }
            }
        }
    }
</script>

<style scoped>

</style>
